// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2KoYG","imageUploader":"EGiftCard_imageUploader__2Ag-9"};